import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Password } from "primereact/password";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";

export default function SelectRole(props) {
    const [user, setUser] = useState(null);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        var user = util.getCurrentUser();
        setUser(user);
        console.log("user is>", user);
    }, []);
    const saveItem = function(index){
        var user = util.getCurrentUser();
        var roles = user.SelectableRoles[index];
        var schId = "";
        if((roles.school)&&(roles.school != null)){
            schId = roles.school.id;
        }
        setSaving(true);
        var params = {userId:user.UserId, token:user.Token, schoolId:schId, role:roles.role.id};
        var url = config.Server+`/user/select-role`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    console.log("response is>", response);
                    user.Role = roles.role.id;
                    user.RoleTitle = roles.role.title;
                    if((roles.school)&&(roles.school != null)){
                        user.SchoolId = roles.school.id;
                        user.SchoolTitle = roles.school.schoolName;
                    }
                    else{
                        user.SchoolId = "";
                        user.SchoolTitle = "";
                    }
                    util.setCurrentUser(user);
                    
                    var redirect = "/home";

                    setRedirectUrl(redirect);
                    setSaving(false);
                    props.onAccountChanged();
                    var newurl = config.Client + redirect
                    window.history.pushState({path:newurl},'',newurl);
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false);
            });
    }
    return(
        (redirectUrl != "")
        ?
        <Navigate to={redirectUrl} replace={false}  />
        :
        <>
        <div style={{width:"100%", boxSizing:"border-box", padding:"20px"}}>
            <table style={{width:"100%", minWidth:"250px", maxWidth:"350px", marginLeft:"auto", marginRight:"auto"}}>
                <tbody>
                    <tr>
                        <td style={{width:"100%", textAlign:"center"}}><span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span></td>
                    </tr>
                    <tr>
                        <td style={{fontSize:"1.5em", textAlign:"center"}}>{(user)?user.Firstname + " " + user.Lastname : "-"}</td>
                    </tr>
                    <tr>
                        <td style={{fontSize:"1.5em", textAlign:"center"}}>نقش خود را انتخاب کنید</td>
                    </tr>
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                        <td>
                            {
                                user?
                                <table style={{width:"100%"}}>
                                    <tbody>
                                    {
                                        user.SelectableRoles.map((role, index)=>{
                                            return(
                                                <tr style={{borderTop:"2px solid #b0b0b0", cursor:"pointer"}} onClick={()=>saveItem(index)} className='select-role'>
                                                    <td style={{padding:"20px", fontSize:"12pt"}}>
                                                        {role.role.title}
                                                    </td>
                                                    <td style={{padding:"20px", fontSize:"12pt"}}>
                                                        {role.school ? <>{role.school.schoolName}</>:<></>}
                                                    </td>
                                                    <td style={{padding:"10px"}}>
                                                        <div className="card flex justify-content-center" style={{ direction: "ltr", fontSize:"12pt" }}>
                                                            <img src={require("../lib/images/left-arrow.png")} height={64} className='' style={{}} />
                                                        </div>
                                                        
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>
                                :<></>
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    );
}
